import { useEnv } from '../context/env-context';
import { useSettings } from '../context/settings-context';
import { platformStorefrontUrl } from '../lib/platform-links';

// Resolves the merchant's public storefront base URL. Prefers the configured `merchantUrl`,
// falling back to a platform-derived domain. Null when neither is available.
export function useStorefrontUrl(): string | null {
  const { platform, store_id: storeId } = useEnv();
  const { merchantUrl } = useSettings();

  if (merchantUrl) {
    return /^https?:\/\//i.test(merchantUrl) ? merchantUrl : `https://${merchantUrl}`;
  }

  return platformStorefrontUrl(platform, storeId);
}
